// import 'framework7/dist/css/framework7.ios.min.css';
// import 'framework7/dist/css/framework7.ios.colors.min.css';

import 'framework7/css/framework7.min.css';

import './css/app.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import Scanner from './components/pages/scanner/Scanner.jsx';
import Framework7 from 'framework7/framework7.esm.bundle';
import Framework7React from 'framework7-react';
import handleDeepLink from "./utils/handleDeepLinks";
import setupDeepLinks from "./utils/setupDeepLinks";

Framework7.use(Framework7React);

if (!window.cordova) {
	const currentUrl = window.location.href;
	if (currentUrl.includes('localhost:3000')) {
		handleDeepLink(currentUrl);
	}
}
setupDeepLinks();

ReactDOM.render(<App/>, document.getElementById('root'));
ReactDOM.render(<Scanner ref={(ref) => (window.SCANNER = ref)}/>, document.getElementById('scanner'));
